const INITIAL_STATE = {
  data: {},
  errors: {},

}
const getPriceList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_PRICE_LIST_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_PRICE_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default getPriceList;